export default "__VITE_ASSET__ac7023a3__"